/* unplugin-vue-components disabled */import { render } from "./w-link.vue?vue&type=template&id=24d1e8c0&ts=true"
import script from "./w-link.vue?vue&type=script&lang=ts"
export * from "./w-link.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__